import React, { useContext } from "react";
import { FEATURE_FLAG_NAME } from "common/constants";
import { AuthContext } from "../Authorization/AuthContext";
import { Icon } from "../Common/Icons/LucideIcons";
import { Tooltip } from "../Common/Tooltip";
import { Body } from "../Common/Typography";
import { Container } from "./__styles__/VisibilityPill";

const MAX_CHARACTERS_TO_DISPLAY = 28;

function getUserList({
  hiddenFromPublic,
  accountName,
  publicUserNames = [],
}: {
  hiddenFromPublic: boolean;
  accountName: string;
  publicUserNames?: Array<string>;
}) {
  const allUsers = [
    !hiddenFromPublic ? "guest users" : "",
    ...publicUserNames,
    `${accountName} Team`,
  ].filter(Boolean);

  let displayedUsers: Array<string> = [];
  let remainingUsers: Array<string> = [];
  for (let i = 0; i < allUsers.length; i++) {
    const user = allUsers[i]!;
    const newDisplayedUsers = [...displayedUsers, user];
    if (newDisplayedUsers.join(", ").length >= MAX_CHARACTERS_TO_DISPLAY) {
      remainingUsers = allUsers.slice(i);
      break;
    } else {
      displayedUsers = newDisplayedUsers;
    }
  }

  const remainingUserCount =
    remainingUsers.length > 0 ? ` +${remainingUsers.length}` : "";

  return {
    displayedUsers: displayedUsers.join(", ") + remainingUserCount,
    remainingUsers: [
      !hiddenFromPublic ? "Guest users (form only)" : "",
      ...remainingUsers,
    ].filter(Boolean),
  };
}

export const VisibilityPill = ({
  hiddenFromPublic,
}: {
  hiddenFromPublic: boolean;
}) => {
  const { account, admin, user, isFeatureEnabled } = useContext(AuthContext);

  // TODO: show pill to relevant public users for submission
  const isInternalUser = admin || user;
  if (
    !isInternalUser ||
    !isFeatureEnabled(FEATURE_FLAG_NAME.SUBMISSION_COMMENTS)
  ) {
    return null;
  }

  const { displayedUsers, remainingUsers } = getUserList({
    hiddenFromPublic,
    accountName: account?.name ?? "",
  });

  const content = (
    <Container>
      <Icon iconName="users" color="contentSecondary" size={16} />
      <Body type="regular" size="small" color="contentSecondary">
        Shared with {displayedUsers}
      </Body>
    </Container>
  );

  if (remainingUsers.length > 0) {
    return (
      <Tooltip
        content={content}
        popoverContent={
          <>
            {remainingUsers.map((user, index) => (
              <div key={index}>{user}</div>
            ))}
          </>
        }
        place="bottom"
        leftSpace={false}
      />
    );
  }

  return content;
};
